var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayoutAmountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FFFF00",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 26V25.3478C11 23.9641 11.5268 22.637 12.4645 21.6586C13.4021 20.6801 14.6739 20.1304 16 20.1304H17.25C18.5761 20.1304 19.8479 20.6801 20.7855 21.6586C21.7232 22.637 22.25 23.9641 22.25 25.3478V26M19.75 14.2609C19.75 15.1257 19.4208 15.9551 18.8347 16.5667C18.2487 17.1782 17.4538 17.5217 16.625 17.5217C15.7962 17.5217 15.0013 17.1782 14.4153 16.5667C13.8292 15.9551 13.5 15.1257 13.5 14.2609C13.5 13.396 13.8292 12.5666 14.4153 11.9551C15.0013 11.3436 15.7962 11 16.625 11C17.4538 11 18.2487 11.3436 18.8347 11.9551C19.4208 12.5666 19.75 13.396 19.75 14.2609Z",
    stroke: "#FFA500",
    strokeWidth: 1.28,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.1429V10H25.1429V15.1429H24ZM24 18V16.8571H25.1429V18H24Z",
    fill: "#FFA500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutAmountIcon);
export default __webpack_public_path__ + "static/media/PayoutAmountIcon.83253f0852d366ebfd024b861b9db6b4.svg";
export { ForwardRef as ReactComponent };